module.exports = __webpack_public_path__ + "img/32_7.15490200.png";